import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import useFontSize from '../../shell/hooks/useFontSize';
import ImageClass from '../../shell/Image';
import { nFormatter } from '../../utils/nFormatter';
import { InstaAvatar } from './InstaAvatar';
import { InstaProfileINT } from './interfaces';

interface InstaProfileProps {
    profile: InstaProfileINT,
}
export const InstaProfile: React.FC<InstaProfileProps> = ({ profile }) => {
    const styles = StyleSheet.create({
        profileContainer: {
            flexDirection: "row",
            justifyContent: "space-around",
            marginTop: "2%",
            borderBottomColor: "#e2e2e2b5",
            borderBottomWidth: 1,
            marginBottom: 20
        },
        profilePicContainer: {
            margin: 0,
            overflow: "hidden",
            position: "relative",
            flexGrow: 1,
            alignItems: "center"
        },

        profileDetailsContainer: {
            flexGrow: 2,
        },
        profileName: {

            color:"black",
            marginBottom: 20,
        },
        postsContainer: {
            flexDirection: "row",
            fontSize: 16,

            marginBottom: 20

        },
        profileTitle: {
            fontSize: useFontSize(3),
            color:"black",
            fontWeight: "300"
        },
        postsLine: {
            color:"black",
            fontSize: 16
        },
        postsText: {
            color:"black",
            fontWeight: "600"
        },
        descriptionContainer: {

        },
        descriptionText: {
            color:"black",
            fontSize: 16,
            marginBottom: 20
        },
    });

    return (
        <View style={styles.profileContainer}>
            <View style={styles.profilePicContainer}>
                <InstaAvatar size={100} profilePic={ImageClass._globalImages.get(profile.instaProfileImage!.key)?.url || profile.instaProfileImage.url}></InstaAvatar>
            </View>

            <View style={styles.profileDetailsContainer}>
                <View style={styles.profileName}>
                    <Text style={styles.profileTitle}>{profile.instaProfileName}</Text>
                </View>
                <View style={styles.postsContainer}>
                    <Text style={[styles.postsLine, { marginRight: 40 }]}><Text style={styles.postsText}>{nFormatter(profile.images.length)}</Text> posts</Text>
                    <Text style={[styles.postsLine, { marginRight: 40 }]}><Text style={styles.postsText}>{nFormatter(profile.followers)}</Text> followers</Text>
                    <Text style={styles.postsLine}><Text style={styles.postsText}>{nFormatter(profile.following)}</Text> following</Text>
                </View>
                <View style={styles.descriptionContainer}>
                    <Text style={styles.descriptionText}>{profile.description}</Text>

                </View>
            </View>
        </View>
    );
};